import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UpsellBaseModal } from '../CampaignUpsellModals/UpsellBaseModal';
import { CAMPAIGN_EVALUATION_REWARD_ARTS } from '../../utils/campaignEvaluationSession';
import { CampaignStarRating } from './CampaignStarRating';
import styles from './styles.module.css';

const GiftIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M20 12V20H4V12M2 7H22V12H2V7ZM12 20V7M12 7H8.5C7.57 7 6.68 6.63 6.05 6C5.42 5.37 5.05 4.48 5.05 3.55C5.05 2.62 5.42 1.73 6.05 1.1C6.68 0.47 7.57 0.1 8.5 0.1C10.71 0.1 12 2.24 12 2.24C12 2.24 13.29 0.1 15.5 0.1C16.43 0.1 17.32 0.47 17.95 1.1C18.58 1.73 18.95 2.62 18.95 3.55C18.95 4.48 18.58 5.37 17.95 6C17.32 6.63 16.43 7 15.5 7H12Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CampaignEvaluationModal = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting = false,
}) => {
  const { t } = useTranslation();
  const [rating, setRating] = useState(0);

  const handleClose = () => {
    if (isSubmitting) {
      return;
    }

    setRating(0);
    onClose?.();
  };

  const handleSubmit = async () => {
    if (!rating || isSubmitting) {
      return;
    }

    await onSubmit?.(rating);
    setRating(0);
  };

  return (
    <UpsellBaseModal
      isOpen={isOpen}
      onClose={handleClose}
      className={styles.modal}
      title={t('chatsocket.avaliation.header')}
      subtitle={t('chatsocket.avaliation.body')}
      titleId="campaign-evaluation-title"
      contentClassName={styles.content}
      primaryAction={{
        label: t('chatsocket.avaliation.send'),
        loadingLabel: t('chatsocket.avaliation.send_loading'),
        loading: isSubmitting,
        onClick: handleSubmit,
        disabled: !rating || isSubmitting,
      }}
      secondaryAction={{
        label: t('chatsocket.avaliation.not_now'),
        onClick: handleClose,
        disabled: isSubmitting,
      }}
    >
      <CampaignStarRating rating={rating} onChange={setRating} />

      <div className={styles.rewardBadge}>
        <span className={styles.rewardBadgeIcon}>
          <GiftIcon />
        </span>
        <span>
          {t('chatsocket.avaliation.reward_badge', {
            count: CAMPAIGN_EVALUATION_REWARD_ARTS,
          })}
        </span>
      </div>
    </UpsellBaseModal>
  );
};

CampaignEvaluationModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};
